// import React, { useState, useEffect, useRef } from "react";
// import { FaChevronDown, FaChevronUp, FaCommentAlt } from "react-icons/fa";
// import { useLoader } from "../../../context/LoaderProvider.jsx";
// const Mainlandingadvertise = () => {
//     const [isLoading, setIsLoading] = useState(false);
//     const [coupons, setCoupons] = useState([]);
//     const { showLoader, hideLoader } = useLoader();
//     const scrollContainerRef = useRef(null);
//     const isMobile = window.innerWidth <= 768;

//     const [isOpen, setIsOpen] = useState(false);
//     const [message, setMessage] = useState("");
//     const [ticketType, setTicketType] = useState("");
//     const [attachment, setAttachment] = useState("");

//     const handleImageChange = (e) => {
//         const file = e.target.files[0];
//         if (file) {
//             const reader = new FileReader();
//             reader.onloadend = () => {
//                 const result = reader.result;
//                 const base64Data = result.split(",")[1];
//                 setAttachment(base64Data);
//             };
//             reader.readAsDataURL(file);
//         }
//     };

//     const handleSendTicket = async () => {
//         const vendorId = localStorage.getItem("vendorId");
//         const token = localStorage.getItem("authToken");

//         if (!vendorId || !token) {
//             alert("Vendor ID or Token not found in localStorage.");
//             return;
//         }

//         if (!ticketType || !message) {
//             alert("Please fill all the fields");
//             return;
//         }

//         const payload = {
//             vendorId: Number(vendorId),
//             ticketType,
//             message,
//             attachmentUrl: attachment || "",
//         };

//         try {
//             showLoader();
//             const response = await fetch(
//                 "https://backend.maamaas.com/food/api/vendor-tickets/create",
//                 {
//                     method: "POST",
//                     headers: {
//                         "Content-Type": "application/json",
//                         Authorization: `Bearer ${token}`,
//                     },
//                     body: JSON.stringify(payload),
//                 }
//             );

//             const result = await response.json();

//             if (response.ok) {
//                 alert("Ticket submitted successfully!");
//                 setTicketType("");
//                 setMessage("");
//                 setAttachment("");
//                 setIsOpen(false);
//             } else {
//                 console.error("API Error:", result);
//                 alert(result.message || "Failed to submit ticket.");
//             }
//         } catch (error) {
//             console.error("Fetch Error:", error);
//             alert("Something went wrong while submitting the ticket.");
//         } finally {
//             hideLoader();
//         }
//     };

//     // Scroll animation
//     useEffect(() => {
//         const container = scrollContainerRef.current;
//         if (!container) return;

//         let scrollStep = 1;
//         let scrollInterval = setInterval(() => {
//             if (container.scrollTop + container.clientHeight >= container.scrollHeight) {
//                 container.scrollTop = 0;
//             } else {
//                 container.scrollTop += scrollStep;
//             }
//         }, 50);

//         return () => clearInterval(scrollInterval);
//     }, []);

//     // Fetch coupons API
//     useEffect(() => {
//         const fetchCoupons = async () => {
//             const vendorId = localStorage.getItem("vendorId");
//             const token = localStorage.getItem("authToken");
//             if (!vendorId || !token) return;

//             setIsLoading(true);

//             try {
//                 showLoader();
//                 const res = await fetch(
//                     `https://backend.maamaas.com/food/api/coupon`,
//                     {
//                         headers: {
//                             Accept: "*/*",
//                             Authorization: `Bearer ${token}`,
//                         },
//                     }
//                 );

//                 const data = await res.json();

//                 if (Array.isArray(data)) {
//                     // ✅ Filter coupons where vendorId is null or 0
//                     const filteredCoupons = data.filter(
//                         (coupon) => coupon.vendorId === null || coupon.vendorId === 0
//                     );
//                     setCoupons(filteredCoupons);
//                 }
//             } catch (err) {
//                 console.error("Coupon API Error:", err);
//             } finally {
//                 setIsLoading(false);
//                 hideLoader();
//             }
//         };

//         fetchCoupons();
//     }, []);


//     return (
//         <div className="container-fluid">
//             <div className="row">
//                 <div className="col-lg-2"></div>
//                 <div
//                     style={{ marginTop: isMobile ? "50px" : "0px" }}
//                     className="col-lg-7 col-md-7 col-sm-12 col-12 subscription-home"
//                 ></div>

//                 {/* Right Sidebar */}
//                 <div className="col-lg-3">
//                     <div
//                         style={{
//                             position: "fixed",
//                             top: "95px",
//                             bottom: "20px",
//                             right: "16px",
//                             width: "20vw",
//                             borderRadius: "8px",
//                             padding: "10px",
//                             display: "flex",
//                             flexDirection: "column",
//                         }}
//                         className="mobilescroll"
//                     >
//                         <div
//                             ref={scrollContainerRef}
//                             style={{
//                                 flexGrow: 1,
//                                 overflowY: "auto",
//                                 paddingRight: "5px",
//                                 scrollbarWidth: "none",
//                                 msOverflowStyle: "none",
//                             }}
//                             className="hide-scrollbar"
//                         >


//                             {coupons.map((coupon) => {
//                                 // Format dates
//                                 const formatDate = (dateStr) => {
//                                     const date = new Date(dateStr);
//                                     const day = String(date.getDate()).padStart(2, "0");
//                                     const month = String(date.getMonth() + 1).padStart(2, "0");
//                                     const year = date.getFullYear();
//                                     return `${day}/${month}/${year}`;
//                                 };

//                                 return (
//                                     <div
//                                         key={coupon.vendorRequirementCouponId}
//                                         className="card "
//                                         style={{
//                                             height: "20vh",
//                                             marginBottom: "15px",
//                                             borderRadius: "8px",
//                                             boxShadow: "0px 2px 4px rgba(0,0,0,0.2)",
//                                             overflow: "hidden",
//                                             position: "relative",
//                                             color: "#fff",
//                                         }}
//                                     >
//                                         {/* Background Image */}
//                                         {coupon.image && (
//                                             <img
//                                                 src={`data:image/png;base64,${coupon.image}`}
//                                                 alt={coupon.couponCode}
//                                                 style={{
//                                                     width: "100%",
//                                                     height: "100%",
//                                                     objectFit: "cover",
//                                                     position: "absolute",
//                                                     top: 0,
//                                                     left: 0,
//                                                     zIndex: 0,
//                                                 }}
//                                             />
//                                         )}

//                                         {/* Overlay content */}
//                                         <div
//                                             style={{
//                                                 position: "absolute",
//                                                 top: 0,
//                                                 left: 0,
//                                                 width: "100%",
//                                                 height: "100%",
//                                                 padding: "10px",
//                                                 display: "flex",
//                                                 flexDirection: "column",
//                                                 justifyContent: "space-between",
//                                                 background: "rgba(0,0,0,0.25)",
//                                                 zIndex: 1,
//                                             }}
//                                         >
//                                             {/* Top row: Dates */}
//                                             <div
//                                                 style={{
//                                                     display: "flex",
//                                                     justifyContent: "space-between",
//                                                     fontSize: "12px",
//                                                     fontWeight: "bold",
//                                                 }}
//                                             >
//                                                 <span>From: {formatDate(coupon.startDate)}</span>
//                                                 <span>To: {formatDate(coupon.endDate)}</span>
//                                             </div>
//                                             <h6 style={{ fontWeight: "bold", fontSize: "16px", marginTop: "-20px", }}>
//                                                 {coupon.code}
//                                             </h6>
//                                             {/* Middle row: Coupon Code & Discount */}
//                                             <div
//                                                 style={{
//                                                     display: "flex",
//                                                     flexDirection: "column",
//                                                     justifyContent: "center",
//                                                     alignItems: "center",
//                                                     textAlign: "center",

//                                                     gap: "5px", // small spacing between elements
//                                                 }}
//                                             >

//                                                 <span
//                                                     style={{
//                                                         fontSize: "14px",
//                                                         fontWeight: "bold",
//                                                         color: "#ffd700",
//                                                     }}
//                                                 >
//                                                     {coupon.discountPercentage}% off
//                                                 </span>
//                                                 <div
//                                                     style={{
//                                                         fontSize: "12px",
//                                                         lineHeight: "14px",
//                                                         maxWidth: "90%", // optional: prevent long text from stretching too wide
//                                                     }}
//                                                 >
//                                                     {coupon.description}
//                                                 </div>
//                                             </div>


//                                             {/* Bottom row: Description */}

//                                         </div>
//                                     </div>
//                                 );
//                             })}

//                         </div>

//                         {/* Support Chat */}
//                         {/* <div
//                             style={{
//                                 position: "fixed",
//                                 bottom: "0px",
//                                 right: "23px",
//                                 width: "19vw",
//                                 backgroundColor: "#fff",
//                                 boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
//                                 borderRadius: "10px",
//                                 overflow: "hidden",
//                                 transition: "height 0.3s ease-in-out",
//                                 height: isOpen ? "400px" : "50px",
//                                 zIndex: 9999,
//                             }}
//                         >
//                             <div
//                                 style={{
//                                     backgroundColor: "#b15cd6",
//                                     color: "#fff",
//                                     padding: "10px",
//                                     fontWeight: "bold",
//                                     textAlign: "center",
//                                     display: "flex",
//                                     alignItems: "center",
//                                     justifyContent: "space-between",
//                                     cursor: "pointer",
//                                 }}
//                                 onClick={() => setIsOpen(!isOpen)}
//                             >
//                                 <FaCommentAlt style={{ marginLeft: "10px" }} />
//                                 <span style={{ flexGrow: 1, textAlign: "center" }}>Support</span>
//                                 {isOpen ? (
//                                     <FaChevronDown style={{ marginRight: "10px" }} />
//                                 ) : (
//                                     <FaChevronUp style={{ marginRight: "10px" }} />
//                                 )}
//                             </div>

//                             {isOpen && (
//                                 <div
//                                     style={{
//                                         display: "flex",
//                                         flexDirection: "column",
//                                         flex: 1,
//                                         overflowY: "auto",
//                                         padding: "10px",
//                                         height: "352px",
//                                         scrollbarWidth: "none",
//                                     }}
//                                 >
//                                     <h4 style={{ textAlign: "center", marginBottom: "10px" }}>Raise a Ticket</h4>

//                                     <label style={{ fontWeight: "bold" }}>Ticket Type</label>
//                                     <select
//                                         value={ticketType}
//                                         onChange={(e) => setTicketType(e.target.value)}
//                                         style={{
//                                             marginBottom: "10px",
//                                             padding: "8px",
//                                             borderRadius: "5px",
//                                             border: "1px solid #ccc",
//                                             outline: "none",
//                                         }}
//                                     >
//                                         <option value="">Select Ticket Type</option>
//                                         <option value="PAYOUT_ISSUE">Payout Issue</option>
//                                         <option value="SUBSCRIPTION_ISSUE">Subscription Issue</option>
//                                         <option value="ORDER_COMPLAINT">Order Complaint</option>
//                                         <option value="TECHNICAL_SUPPORT">Technical Support</option>
//                                         <option value="OTHER">Other</option>
//                                     </select>

//                                     <label style={{ fontWeight: "bold" }}>Message</label>
//                                     <input
//                                         value={message}
//                                         onChange={(e) => setMessage(e.target.value)}
//                                         placeholder="Type your Issue here..."
//                                         rows={3}
//                                         style={{
//                                             marginBottom: "10px",
//                                             padding: "8px",
//                                             borderRadius: "5px",
//                                             border: "1px solid #ccc",
//                                             height: "50px",
//                                         }}
//                                     />

//                                     <label style={{ fontWeight: "bold" }}>Attachment</label>
//                                     <input
//                                         type="file"
//                                         accept="image/*"
//                                         onChange={handleImageChange}
//                                         style={{ marginBottom: "10px" }}
//                                     />

//                                     <button
//                                         onClick={handleSendTicket}
//                                         style={{
//                                             padding: "10px",
//                                             backgroundColor: "#b15cd6",
//                                             color: "#fff",
//                                             border: "none",
//                                             borderRadius: "5px",
//                                             fontWeight: "bold",
//                                             cursor: "pointer",
//                                         }}
//                                     >
//                                         Send Ticket
//                                     </button>
//                                 </div>
//                             )}
//                         </div> */}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Mainlandingadvertise;





import React, { useState, useEffect, useRef } from "react";
import { FaChevronDown, FaChevronUp, FaCommentAlt } from "react-icons/fa";
import { useLoader } from "../../../context/LoaderProvider.jsx";
const Mainlandingadvertise = () => {
  
    const [isLoading, setIsLoading] = useState(false);
    const [coupons, setCoupons] = useState([]);
    const { showLoader, hideLoader } = useLoader();
    const scrollContainerRef = useRef(null);
    const isMobile = window.innerWidth <= 768;

    const [isOpen, setIsOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [ticketType, setTicketType] = useState("");
    const [attachment, setAttachment] = useState("");

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const result = reader.result;
                const base64Data = result.split(",")[1];
                setAttachment(base64Data);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSendTicket = async () => {
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        if (!vendorId || !token) {
            alert("Vendor ID or Token not found in localStorage.");
            return;
        }

        if (!ticketType || !message) {
            alert("Please fill all the fields");
            return;
        }

        const payload = {
            vendorId: Number(vendorId),
            ticketType,
            message,
            attachmentUrl: attachment || "",
        };

        try {
            showLoader();
            const response = await fetch(
                "https://backend.maamaas.com/food/api/vendor-tickets/create",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify(payload),
                }
            );

            const result = await response.json();

            if (response.ok) {
                alert("Ticket submitted successfully!");
                setTicketType("");
                setMessage("");
                setAttachment("");
                setIsOpen(false);
            } else {
                console.error("API Error:", result);
                alert(result.message || "Failed to submit ticket.");
            }
        } catch (error) {
            console.error("Fetch Error:", error);
            alert("Something went wrong while submitting the ticket.");
        } finally {
            hideLoader();
        }
    };

    // Fetch coupons API - REPLACED WITH NEW API
    useEffect(() => {
        const fetchCoupons = async () => {
            const vendorId = localStorage.getItem("vendorId");
            const token = localStorage.getItem("authToken");
            if (!vendorId || !token) return;

            setIsLoading(true);

            try {
                showLoader();

                // Use the new API endpoint
                const res = await fetch(
                    `https://backend.maamaas.com/food/api/vendor/coupon/getByVendor/${vendorId}`,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json',
                            'Authorization': `Bearer ${token}`
                        }
                    }
                );

                const data = await res.json();

                // Handle different response formats and filter for PAID offers only
                let offersArray = [];
                if (Array.isArray(data)) {
                    offersArray = data;
                } else if (data && Array.isArray(data.data)) {
                    offersArray = data.data;
                } else if (data && data.success && Array.isArray(data.result)) {
                    offersArray = data.result;
                }

                // ✅ Filter coupons where paymentStatus is PAID (not vendorId null or 0)
                const filteredCoupons = offersArray
                    .filter((coupon) => coupon.paymentStatus === 'PAID')
                    .map(coupon => ({
                        // Map to your existing coupon structure
                        vendorRequirementCouponId: coupon.vendorRequirementCouponId,
                        vendorId: coupon.vendorId,
                        image: coupon.image || "",
                        couponCode: coupon.couponCode || coupon.code || "",
                        code: coupon.couponCode || coupon.code || "",
                        discountPercentage: coupon.discount || 0,
                        description: coupon.description || "",
                        startDate: coupon.startDate,
                        endDate: coupon.endDate,
                        // Keep the original fields
                        amount: coupon.amount,
                        paymentStatus: coupon.paymentStatus
                    }));

                setCoupons(filteredCoupons);
            } catch (err) {
                console.error("Coupon API Error:", err);
                setCoupons([]); // Set empty array on error
            } finally {
                setIsLoading(false);
                hideLoader();
            }
        };

        fetchCoupons();
    }, []);

    // Scroll animation (only if there are coupons)
    useEffect(() => {
        if (coupons.length === 0) return;

        const container = scrollContainerRef.current;
        if (!container) return;

        let scrollStep = 1;
        let scrollInterval = setInterval(() => {
            if (container.scrollTop + container.clientHeight >= container.scrollHeight) {
                container.scrollTop = 0;
            } else {
                container.scrollTop += scrollStep;
            }
        }, 50);

        return () => clearInterval(scrollInterval);
    }, [coupons.length]);

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-2"></div>
                <div
                    style={{ marginTop: isMobile ? "50px" : "0px" }}
                    className="col-lg-7 col-md-7 col-sm-12 col-12 subscription-home"
                ></div>

                {/* Right Sidebar */}
                <div className="col-lg-3">
                    <div
                        style={{
                            position: "fixed",
                            top: "110px",
                            bottom: "20px",
                            right: "5px",
                            width: window.innerWidth < 1400 ? "20vw" : "20vw",
                            borderRadius: "8px",
                            padding: "10px",
                            display: "flex",
                            flexDirection: "column",
                        }}
                        className="mobilescroll"
                    >
                        <div
                            ref={scrollContainerRef}
                            style={{
                                flexGrow: 1,
                                overflowY: "auto",
                                paddingRight: "5px",
                                scrollbarWidth: "none",
                                msOverflowStyle: "none",
                            }}
                            className="hide-scrollbar"
                        >
                            {coupons.map((coupon) => {
                                // Format dates - EXACT SAME AS BEFORE
                                const formatDate = (dateStr) => {
                                    const date = new Date(dateStr);
                                    const day = String(date.getDate()).padStart(2, "0");
                                    const month = String(date.getMonth() + 1).padStart(2, "0");
                                    const year = date.getFullYear();
                                    return `${day}/${month}/${year}`;
                                };

                                return (
                                    <div
                                        key={coupon.vendorRequirementCouponId}
                                        className="card "
                                        style={{
                                            height: "20vh",
                                            marginBottom: "15px",
                                            borderRadius: "8px",
                                            boxShadow: "0px 2px 4px rgba(0,0,0,0.2)",
                                            overflow: "hidden",
                                            position: "relative",
                                            color: "#fff",
                                        }}
                                    >
                                        {/* Background Image - EXACT SAME AS BEFORE */}
                                        {coupon.image && (
                                            <img
                                                src={`data:image/png;base64,${coupon.image}`}
                                                alt={coupon.couponCode}
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                    position: "absolute",
                                                    top: 0,
                                                    left: 0,
                                                    zIndex: 0,
                                                }}
                                            />
                                        )}

                                        {/* Overlay content - EXACT SAME AS BEFORE */}
                                        <div
                                            style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                width: "100%",
                                                height: "100%",
                                                padding: "10px",
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "space-between",
                                                background: "rgba(0,0,0,0.25)",
                                                zIndex: 1,
                                            }}
                                        >
                                            {/* Top row: Dates - EXACT SAME AS BEFORE */}
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    fontSize: "12px",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                <span>From: {formatDate(coupon.startDate)}</span>
                                                <span>To: {formatDate(coupon.endDate)}</span>
                                            </div>
                                            <h6 style={{
                                                fontWeight: "bold", fontSize: "16px", marginTop: "0px", alignItems: "center",
                                                textAlign: "center",
                                            }}>
                                                {coupon.code}
                                            </h6>
                                            {/* Middle row: Coupon Code & Discount - EXACT SAME AS BEFORE */}
                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    textAlign: "center",
                                                    gap: "5px",
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        fontSize: "14px",
                                                        fontWeight: "bold",
                                                        color: "#ffd700",
                                                    }}
                                                >
                                                    {coupon.discountPercentage}% off
                                                </span>
                                                <div
                                                    style={{
                                                        fontSize: "12px",
                                                        lineHeight: "14px",
                                                        maxWidth: "90%",
                                                    }}
                                                >
                                                    {/* {coupon.description} */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}

                            {/* Show message when no coupons */}
                            {!isLoading && coupons.length === 0 && (
                                <div style={{
                                    textAlign: "center",
                                    padding: "20px",
                                    color: "#666",
                                    fontSize: "14px"
                                }}>
                                    No paid offers available
                                </div>
                            )}
                        </div>

                        {/* Support Chat - EXACT SAME AS BEFORE (commented out) */}
                        {/* <div
                                style={{
                                    position: "fixed",
                                    bottom: "0px",
                                    right: "23px",
                                    width: "19vw",
                                    backgroundColor: "#fff",
                                    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                                    borderRadius: "10px",
                                    overflow: "hidden",
                                    transition: "height 0.3s ease-in-out",
                                    height: isOpen ? "400px" : "50px",
                                    zIndex: 9999,
                                }}
                            >
                                <div
                                    style={{
                                        backgroundColor: "#b15cd6",
                                        color: "#fff",
                                        padding: "10px",
                                        fontWeight: "bold",
                                        textAlign: "center",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => setIsOpen(!isOpen)}
                                >
                                    <FaCommentAlt style={{ marginLeft: "10px" }} />
                                    <span style={{ flexGrow: 1, textAlign: "center" }}>Support</span>
                                    {isOpen ? (
                                        <FaChevronDown style={{ marginRight: "10px" }} />
                                    ) : (
                                        <FaChevronUp style={{ marginRight: "10px" }} />
                                    )}
                                </div>
    
                                {isOpen && (
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            flex: 1,
                                            overflowY: "auto",
                                            padding: "10px",
                                            height: "352px",
                                            scrollbarWidth: "none",
                                        }}
                                    >
                                        <h4 style={{ textAlign: "center", marginBottom: "10px" }}>Raise a Ticket</h4>
    
                                        <label style={{ fontWeight: "bold" }}>Ticket Type</label>
                                        <select
                                            value={ticketType}
                                            onChange={(e) => setTicketType(e.target.value)}
                                            style={{
                                                marginBottom: "10px",
                                                padding: "8px",
                                                borderRadius: "5px",
                                                border: "1px solid #ccc",
                                                outline: "none",
                                            }}
                                        >
                                            <option value="">Select Ticket Type</option>
                                            <option value="PAYOUT_ISSUE">Payout Issue</option>
                                            <option value="SUBSCRIPTION_ISSUE">Subscription Issue</option>
                                            <option value="ORDER_COMPLAINT">Order Complaint</option>
                                            <option value="TECHNICAL_SUPPORT">Technical Support</option>
                                            <option value="OTHER">Other</option>
                                        </select>
    
                                        <label style={{ fontWeight: "bold" }}>Message</label>
                                        <input
                                            value={message}
                                            onChange={(e) => setMessage(e.target.value)}
                                            placeholder="Type your Issue here..."
                                            rows={3}
                                            style={{
                                                marginBottom: "10px",
                                                padding: "8px",
                                                borderRadius: "5px",
                                                border: "1px solid #ccc",
                                                height: "50px",
                                            }}
                                        />
    
                                        <label style={{ fontWeight: "bold" }}>Attachment</label>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={handleImageChange}
                                            style={{ marginBottom: "10px" }}
                                        />
    
                                        <button
                                            onClick={handleSendTicket}
                                            style={{
                                                padding: "10px",
                                                backgroundColor: "#b15cd6",
                                                color: "#fff",
                                                border: "none",
                                                borderRadius: "5px",
                                                fontWeight: "bold",
                                                cursor: "pointer",
                                            }}
                                        >
                                            Send Ticket
                                        </button>
                                    </div>
                                )}
                            </div> */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Mainlandingadvertise;
